import { getJWTToken } from '../../utils/auth';
import { authHeaders } from '../../core/impersonation';

const apiUrl = import.meta.env.REACT_APP_BAMBOO_API_URL ?? '';

export const UNKNOWN_PARTITION = 'unknown';

export type UploadDistrictRow = {
  partition: string;
  districtName?: string;
  sandboxEmail?: string;
  uploads: number;
  lastUploadedAt?: string;
};

export type AdminUploadListItem = {
  id: string;
  name: string;
  schoolYear: string;
  version: number;
  kind?: string;
  uploadedAt?: string;
};

async function authorizedGet(path: string): Promise<Response> {
  const token = await getJWTToken();
  return fetch(`${apiUrl}${path}`, {
    headers: authHeaders(token),
  });
}

export async function fetchUploadDistricts(): Promise<UploadDistrictRow[]> {
  const response = await authorizedGet('/admin/uploads');
  if (!response.ok) {
    throw new Error(`admin-uploads fetch failed: ${response.status}`);
  }
  const data = (await response.json()) as { districts?: UploadDistrictRow[] | null };
  return data.districts ?? [];
}

export type AdminUploadFile = {
  id: string;
  name: string;
  kind?: string;
  csv: string;
};

export async function fetchUploadFile(
  partition: string,
  schoolYear: string,
  version: number,
): Promise<AdminUploadFile> {
  const path = `/admin/uploads/${encodeURIComponent(partition)}/${encodeURIComponent(schoolYear)}/${version}`;
  const response = await authorizedGet(path);
  if (!response.ok) {
    throw new Error(`admin-uploads file fetch failed: ${response.status}`);
  }
  return (await response.json()) as AdminUploadFile;
}

export async function fetchPartitionUploads(partition: string): Promise<AdminUploadListItem[]> {
  return partitionUploads(partition, '');
}

export async function fetchDeletedPartitionUploads(
  partition: string,
): Promise<AdminUploadListItem[]> {
  return partitionUploads(partition, '?deleted=true');
}

async function partitionUploads(partition: string, query: string): Promise<AdminUploadListItem[]> {
  const response = await authorizedGet(`/admin/uploads/${encodeURIComponent(partition)}${query}`);
  if (!response.ok) {
    throw new Error(`admin-uploads partition fetch failed: ${response.status}`);
  }
  return ((await response.json()) as AdminUploadListItem[] | null) ?? [];
}
